exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1v21rVhN13rvXEGU8zVDCa,._18kdlOjmxDoG7Ez0atu5tK{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._2ceoObYVbQg6giwCoCdwrZ{margin:\"0 0 3px\"}", ""]);

// exports
exports.locals = {
	"publishPbpSection": "_1v21rVhN13rvXEGU8zVDCa",
	"publishToggleSection": "_18kdlOjmxDoG7Ez0atu5tK",
	"spinner": "_2ceoObYVbQg6giwCoCdwrZ"
};